export interface ValidationError {
  key: string;
  message: string;
}

export interface IValidator<TEntity> {
  validate(item: TEntity): ValidationResult;
}

export class ValidationResult {
  public readonly isValid: boolean;

  constructor(public errors: ValidationError[] = []) {
    errors = errors || [];
    this.isValid = !errors.length;
  }
}
